(() => {
	// Matches $bp-lg -- the testimonial track's own desktop breakpoint.
	const DESKTOP = 992;

	// Matches $bp-md. Where "Mobile only" hands layout back to CSS. Deliberately
	// lower than DESKTOP: by 768 there's room for two pricing cards side by side,
	// and a pair of 270px slides in a 718px track leaves obvious dead space with
	// arrows that have nothing to scroll to. Has to agree with the stylesheet.
	const STATIC_ROW = 768;

	// Where each "Mobile only" track hands layout back to CSS. Four step cards
	// sharing a 768px row come out around 160px wide, so that one stays a slider
	// until there's a full content column to divide.
	const staticRowFor = (type) => (type === 'step' ? DESKTOP : STATIC_ROW);

	const configFor = (type) => {
		// Stacked, all three are a centred track with the neighbours peeking
		// either side. Widths come from CSS, so `auto` lets the stylesheet own
		// every size.
		if (type === 'feature' || type === 'icon' || type === 'step') {
			return {
				slidesPerView: 'auto',
				spaceBetween: 12,
				centeredSlides: true,
				loop: false,
				// The run ends on a card lined up on the content column, leaving
				// the spare space past the last card, instead of Swiper's default
				// of pinning the last card to the viewport edge and cutting the
				// first visible one in half.
				snapToSlideEdge: true,
				breakpoints: {
					[DESKTOP]: { spaceBetween: 24, centeredSlides: false },
				},
			};
		}

		if (type === 'pricing') {
			return {
				// The comp lines the first pricing card up on the page gutter with
				// the next one peeking past the right edge, rather than centring
				// the active card the way the testimonials do. Widths come from
				// CSS, so `auto` lets the stylesheet own the mobile card size.
				slidesPerView: 'auto',
				spaceBetween: 12,
				centeredSlides: false,
				loop: false,
			};
		}

		return {
			slidesPerView: 1,
			// Figma sets the cards 24px apart on mobile and 88px on desktop.
			spaceBetween: 24,
			centeredSlides: true,
			loop: true,
			breakpoints: {
				[DESKTOP]: { spaceBetween: 88 },
			},
		};
	};

	document.querySelectorAll('.block-slider').forEach((block) => {
		const viewport = block.querySelector('.block-slider__viewport');
		const prev = block.querySelector('.block-slider__arrow--prev');
		const next = block.querySelector('.block-slider__arrow--next');
		if (!viewport || typeof window.Swiper === 'undefined') {
			return;
		}

		const type = block.dataset.slideType || 'testimonial';
		const options = {
			modules: [window.SwiperNavigation],
			...configFor(type),
			navigation: {
				nextEl: next,
				prevEl: prev,
			},
		};

		// "Always" is the original behaviour: one instance, for the life of the
		// page.
		if (block.dataset.slideOn !== 'mobile') {
			new window.Swiper(viewport, options);
			return;
		}

		// "Mobile only": the pricing row is a plain flex row on desktop, so Swiper
		// is torn down rather than left running-but-disabled. `enabled: false` at a
		// breakpoint would stop the interaction but keep Swiper's inline slide
		// widths and wrapper transform in place, which the static layout then has
		// to fight; destroying it removes them outright.
		const query = window.matchMedia(`(max-width: ${staticRowFor(type) - 1}px)`);
		let swiper = null;

		const sync = () => {
			if (query.matches && !swiper) {
				swiper = new window.Swiper(viewport, options);
			} else if (!query.matches && swiper) {
				swiper.destroy(true, true);
				swiper = null;
			}
		};

		sync();
		query.addEventListener('change', sync);
	});
})();
